<template>
  <el-drawer
    ref="drawer"
    :title="config.title"
    :before-close="handleClose"
    :visible.sync="drawer"
    direction="rtl"
    :append-to-body="true"
    custom-class="edit_drawer"
    :wrapper-closable="false"
  >
    <div class="drawer__content">
      <el-form
        ref="form"
        :model="form"
        class="edit_form"
      >
        <formItem :field="config.fields" :form="form">
          <template slot="enterpriseName" slot-scope="{scope}">
            <el-input
              v-model="form.enterpriseName"
              :maxlength="50"
              clearable
              :placeholder="`请输入${scope.label}`"
              @blur="handleBlur('creditCode')"
            />
          </template>
          <template slot="creditCode" slot-scope="{scope}">
            <el-input
              v-model="form.creditCode"
              :maxlength="30"
              clearable
              :placeholder="`请输入${scope.label}`"
              @blur="handleBlur('enterpriseName')"
            />
          </template>
        </formItem>
      </el-form>
      <div class="drawer__footer">
        <el-button :loading="loading.submit" @click="handleClose">
          取 消
        </el-button>
        <el-button
          type="primary"
          :loading="loading.submit"
          @click="handleSubmit()"
        >
          保存
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { mainManageUpsert } from '@/api/principal';
import { referMerchantList } from '@/api/tenant';
import formItem from '@/views/configure/ownerRuleConfig/components/formItem.vue';
import { source, MAIN_TYPE } from '../constant';

export default {
  name: 'EditDialog',
  components: {
    formItem,
  },
  data() {
    return {
      drawer: false,
      loading: {
        submit: false,
      },
      form: {},
      config: {},
    };
  },
  methods: {
    show(config) {
      this.config = config;
      if (config.form && config.form.id) {
        this.form = { ...config.form };
      }
      this.drawer = true;
    },
    handleClose() {
      this.form = {};
      this.$refs.form.clearValidate();
      this.drawer = false;
    },
    async handleBlur(prop) {
      const key = {
        enterpriseName: 'corpCreditCode',
        creditCode: 'corpName',
      };
      const value = {
        enterpriseName: 'creditCode',
        creditCode: 'enterpriseName',
      };
      const params = {
        enterpriseName: 'corpName',
        creditCode: 'creditCode',
      };
      if (this.form[value[prop]] && !this.form[prop]) {
        const res = await referMerchantList({ [key[prop]]: this.form[value[prop]] });
        if (res.length) {
          this.$set(this.form, prop, res[0][params[prop]]);
        }
      }
    },
    async handleSubmit() {
      await this.$refs.form.validate();
      this.loading.submit = true;
      const { creditCode, enterpriseName, id } = this.form;
      const data = {
        id,
        creditCode,
        enterpriseName,
        mainType: MAIN_TYPE[this.config.mainType],
        source: source.PLATFORM,
      };
      try {
        await mainManageUpsert(data);
        this.loading.submit = false;
        this.$message.success('添加成功');
        this.handleClose();
        this.$emit('reset');
      } catch (error) {
        this.loading.submit = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 ::v-deep .edit_drawer {
 .el-drawer__body{
  padding: 0 !important;
}
}
.drawer__content{
  padding: 24px;
}
::v-deep .edit_form{
  .el-form-item__label{
    text-align: left;
  }
}
.drawer__footer{
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 24px;
  width: calc(100% - 48px);
  border-top: 1px solid #EBEEF5;
  text-align: right;
}
</style>
